import "./Initialization.css";
import { Spinner } from "@/components/Spinner";
import { initializationMessages } from "../../utils/loadingMessages";
export const Initialization = () => (
	<div className="flex h-screen w-screen items-center justify-center bg-gradient-to-br bg-primary relative overflow-hidden">
		<div className="absolute bottom-0 w-full bg-blue-500 water-fill"></div>

		<div className="absolute inset-0 flex items-center justify-center z-10 bg-transparent backdrop-blur-sm">
			<Spinner messages={initializationMessages} messageClassName="text-white" size={42} intervalMs={2000} />
		</div>
	</div>
);
